// extracted by mini-css-extract-plugin
export default {"simpleLayout":"SimpleLayout-module__simpleLayout--Mzapq"};